import { NotesTable } from '~features/notes';

interface NotesPageProps {
  studentId: string;
}

export const NotesPage = ({ studentId }: NotesPageProps) => {
  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <h1 className='text-2xl font-semibold'>Notes</h1>
      </div>
      <NotesTable entityId={studentId} />
    </div>
  );
};
